import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { TestimonialsRow } from './components/TestimonialsRow';
import { PainPoints } from './components/PainPoints';
import { ThreeLevels } from './components/ThreeLevels';
import { Level1Detail } from './components/Level1Detail';
import { Level2Detail } from './components/Level2Detail';
import { Level3Detail } from './components/Level3Detail';
import { UrgencyCountdown } from './components/UrgencyCountdown';
import { PricingTable } from './components/PricingTable';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeBlock } from './components/GuaranteeBlock';
import { ChatTestimonials } from './components/ChatTestimonials';
import { FaqAccordion } from './components/FaqAccordion';
import { BeforeAfterTable } from './components/BeforeAfterTable';
import { FinalPricing } from './components/FinalPricing';
import { ClosingManifesto } from './components/ClosingManifesto';
import { Footer } from './components/Footer';
import { FloatingElements } from './components/FloatingElements';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-800 relative" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Hero data-id="element-2" />
      <TestimonialsRow data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ThreeLevels data-id="element-5" />
      <Level1Detail data-id="element-6" />
      <Level2Detail data-id="element-7" />
      <Level3Detail data-id="element-8" />
      <UrgencyCountdown data-id="element-9" />
      <PricingTable data-id="element-10" />
      <ComparisonTable data-id="element-11" />
      <GuaranteeBlock data-id="element-12" />
      <ChatTestimonials data-id="element-13" />
      <FaqAccordion data-id="element-14" />
      <BeforeAfterTable data-id="element-15" />
      <FinalPricing data-id="element-16" />
      <ClosingManifesto data-id="element-17" />
      <Footer data-id="element-18" />
      <FloatingElements data-id="element-19" />
    </div>;
}